import { InlineContainer, InputContainer } from './InputInline.styles';
import { type IInputInline } from './InputInline.types';

export const InputInline = ({ inlineElement = null, children }: IInputInline) => {
  if (!inlineElement) {
    return <>{children}</>;
  }

  return (
    <InlineContainer>
      <InputContainer>{children}</InputContainer>
      {inlineElement}
    </InlineContainer>
  );
};

InputInline.displayName = 'InputInline';
